import { render, staticRenderFns } from "./CopyableText.vue?vue&type=template&id=910f3bda&"
import script from "./CopyableText.vue?vue&type=script&lang=js&"
export * from "./CopyableText.vue?vue&type=script&lang=js&"
import style0 from "./CopyableText.vue?vue&type=style&index=0&id=910f3bda&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports